import { Lessons } from '../types/lessons';

export const sortLessonsByFree = (lessons: Lessons): Lessons => {
  if (!lessons) return [];
  return lessons.sort((a, b) => {
    if (a.free === true && b.free !== true) {
      return -1;
    }
    if (a.free !== true && b.free === true) {
      return 1;
    }
    return 0;
  });
};
